import { HttpRequest } from '../../lib/shared/http-request';
import { HttpRequestVerbs } from '../../lib/shared/http-request-verbs';
import { Injectable } from '@angular/core';
import { ServiceProxyBase } from '../../lib/services/service-proxy-base';

@Injectable()
export class DataWarehouseService {
  accessToken: string;
  constructor(private serviceProxy: ServiceProxyBase) { }

  /*
    GroupData
  */

  // [HttpGet, Route("GroupData/{GroupID}")]
  // public ActionResult Get(float GroupID)
  getGroupData(groupId: number) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.GET;
    httpRequest.uri.host.name = 'DataWarehouse';
    httpRequest.uri.path =  `GroupData/${groupId}`;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }

  // [HttpGet, Route("GroupData/AlternateGroup/{AlternateGroup}")]
  // public ActionResult GetGroupFromAlternate(string AlternateGroup)
  getGroupDataFromAlternate(alternateGroup: string) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.GET;
    httpRequest.uri.host.name = 'DataWarehouse';
    httpRequest.uri.path =  `GroupData/AlternateGroup/${alternateGroup}`;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }

  // [HttpGet, Route("GroupData/new/{Date}")]
  // public ActionResult GetNew(DateTime Date);
  getNewGroupData(date: Date) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.GET;
    httpRequest.uri.host.name = 'DataWarehouse';
    httpRequest.uri.path =  `GroupData/new/${date}`;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }

   /*
    NetworkPharmacies
  */

  // [HttpPost, Route("NetworkPharmacies/new/{Date}"), DisableRequestSizeLimit]
  // public ActionResult GetNewNetworks([FromBody]List<int> NABPs, DateTime Date)
  getNewNetworkPharmacies(nabps: Array<number>, date: Date) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.POST;
    httpRequest.uri.host.name = 'DataWarehouse';
    httpRequest.uri.path =  `NetworkPharmacies/new/${date}`;
    httpRequest.body = nabps;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }

  // [HttpGet, Route("NetworkPharmacies/new/nabps/{Date}")]
  // public IActionResult GetNabps(DateTime Date)
  getNabps(date: Date) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.GET;
    httpRequest.uri.host.name = 'DataWarehouse';
    httpRequest.uri.path =  `NetworkPharmacies/new/nabps/${date}`;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }

  /*
    Pharmacies
  */

  // [HttpGet, Route("Pharmacies/new/{Date}")]
  // public ActionResult Get(DateTime Date)

  getPharmacies(date: Date) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.GET;
    httpRequest.uri.host.name = 'DataWarehouse';
    httpRequest.uri.path =  `Pharmacies/new/${date}`;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }

}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/data-warehouse/data-warehouse.service.ts